'use strict';
const angular = require('angular');

export class imageEditorComponent {

  constructor(StorageService, $uibModal) {
    'ngInject';

    this.StorageService = StorageService;
    this.$uibModal = $uibModal;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    this.imageId = this.config.storageId;
    this.random = (new Date()).getTime();
  };

  ok() {
    this.close();
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  openScale() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'md',
      component: 'imageEditorScale',
      resolve: {
        config: function() {
          return {
            storageId: that.imageId
          }
        }
      }
    });

    modalInstance.result.then(
      function (scalingFactor) {

        that.StorageService.transformImage({id: that.imageId}, {transform: 'scale', factor: scalingFactor}, _ => {
          that.random = (new Date()).getTime();
        }, _ => {
          that.random = (new Date()).getTime();
        })

      },
      function () { /* cancel */ }
    );

  }

  transformImage(action) {
    this.StorageService.transformImage({id: this.imageId}, {transform: action}, _ => {
      this.random = (new Date()).getTime();
    }, _ => {
      this.random = (new Date()).getTime();
    })
  }
}

export default angular.module('conduApp.imageEditor', [])
  .component('imageEditor', {
    template: require('./image-editor.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: imageEditorComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/image-editor/image-editor.component.js